/**
 * 사이트 고정 정보 — 브랜드명과 공통 링크.
 *
 * DB 에서 올 성격은 아니지만 화면 여러 곳에 같은 문자열이 흩어져 있어 모았다.
 * 특히 푸터가 둘(`footer.tsx`, `webzine/webzine-footer.tsx`)인데 링크가 같다.
 *
 * 문서 본문은 `data/legal.ts` 에 있다 (`/terms` · `/service` · `/privacy` ·
 * `/consent` · `/business`).
 */

import type { LegalDocumentId } from './legal.ts';

export const BRAND_NAME = 'urnplay';

export interface SiteLink {
  href: string;
  label: string;
}

/**
 * 로그인·추가정보 화면의 한 줄 푸터 (시안 `_login.html`).
 *
 * 시안은 `href="#"` 에 스크립트로 약관 팝업의 **목록(1단계)** 을 연다. 그래서
 * 이용약관 문서가 아니라 목록 주소(`/terms`)로 보낸다.
 */
export const FOOTER_LINKS: SiteLink[] = [{ href: '/terms', label: '이용약관' }];

/** 웹진 화면의 푸터 (시안 `_index.html` 의 `.wz-footer`) */
export const WEBZINE_FOOTER_LINKS: SiteLink[] = [
  { href: '/service', label: '이용약관' },
  { href: '/privacy', label: '개인정보처리방침' },
];

/** 푸터 브랜드 로고가 가리키는 곳 (회사 소개) */
export const BUSINESS_HREF = '/business';

/**
 * 약관 팝업 목록(1단계) 순서 — `/terms`.
 *
 * 본문은 `data/legal.ts` 에 있지만 여기서는 **타입만** 참조한다. 값을 가져오면
 * 약관 청크가 첫 화면부터 딸려 들어온다.
 */
export const LEGAL_MENU: { id: LegalDocumentId; label: string }[] = [
  { id: 'service', label: '서비스 이용약관' },
  { id: 'privacy', label: '개인정보 처리방침' },
  { id: 'consent', label: '개인정보 수집 · 이용 동의' },
];
